import api from './api';

/**
 * Features Service (Admin)
 * خدمة إدارة الميزات/الصلاحيات
 */
const featuresService = {
    /**
     * الحصول على جميع الميزات
     * @param {Object} params - معاملات البحث
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/features${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * الحصول على ميزة واحدة
     * @param {string} id - معرف الميزة
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/features/${id}`);
    },

    /**
     * إنشاء ميزة جديدة
     * @param {Object} data - بيانات الميزة
     * @returns {Promise<Object>}
     */
    create: async (data) => {
        return api.post('/admin/features', data);
    },

    /**
     * تحديث ميزة
     * @param {string} id - معرف الميزة
     * @param {Object} data - البيانات المحدثة
     * @returns {Promise<Object>}
     */
    update: async (id, data) => {
        return api.patch(`/admin/features/${id}`, data);
    },

    /**
     * تفعيل/تعطيل ميزة
     * @param {string} id - معرف الميزة
     * @returns {Promise<Object>}
     */
    toggle: async (id) => {
        return api.patch(`/admin/features/${id}/toggle`);
    },

    /**
     * حذف ميزة
     * @param {string} id - معرف الميزة
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/features/${id}`);
    },

    /**
     * إنشاء ميزات افتراضية
     * @returns {Promise<Object>}
     */
    seedDefaults: async () => {
        return api.post('/admin/features/seed');
    }
};

export default featuresService;
